import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const postAction = createAsyncThunk<
    { guid: string; actionResult: any },
    {
        product_id: string
        action_name: string
        action_params: Record<string, unknown> | undefined
        client_payload?: Record<string, unknown>
    },
    ThunkConfig<string>
>('actionsSlice/postAction', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { product_id, action_name, action_params = {}, client_payload } = args

    try {
        const { data } = await api.post(getUrlWithVersion(`/actions`), {
            product_id,
            action_name,
            action_params,
            client_payload,
        })

        return { guid: product_id, actionResult: data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to run action')
    }
})
